import api from '../api';

export const updatePrice = (payload) => (dispatch) => {
  dispatch({
    type: 'IS_LOADING',
  });

  let data = {
    id: payload.item.id,
    newPrice: payload.newPrice,
    comments: payload.comments,
    oldPrice: payload.item.Price,
    unitId: payload.item.UnitId,
    type: payload.type,
  };
  if (payload.override) {
    data.override = payload.override;
    data.overrideDays = payload.overrideDays;
  }
  api
    .updatePrice(data)
    .then((res) => {
      if (data.type === 'override')
        dispatch({
          type: 'UPDATE_PRICE',
          payload: payload,
        });
      else if (data.type === 'suggest')
        dispatch({
          type: 'SUGGEST_PRICE',
          payload: res.data,
        });

      dispatch({
        type: 'SHOW_NOTIFICATION',
        payload: {
          message:
            data.type === 'override'
              ? 'Price updated successfully'
              : `Price suggested from £${parseFloat(data.oldPrice).toFixed(
                  2
                )} to £${parseFloat(data.newPrice).toFixed(2)}`,
          type: 'success',
        },
      });
    })
    .catch((err) => {
      if (err.response.status === 401)
        dispatch({
          type: 'LOGOUT',
        });
      else {
        console.log(err.response.data.error);
        dispatch({
          type: 'SHOW_NOTIFICATION',
          payload: { message: err.response.data.error, type: 'error' },
        });
      }
    })
    .finally(() => {
      dispatch({
        type: 'HIDE_UPDATE_PANEL',
      });
      dispatch({
        type: 'IS_NOT_LOADING',
      });
    });
};

export const showUpdatePanel = (data) => (dispatch) => {
  if (data.item.IsOverridden) {
    dispatch({
      type: 'SHOW_CONFIRMATION',
      payload: data,
    });
  } else {
    dispatch({
      type: 'SHOW_UPDATE_PANEL',
      payload: data,
    });
  }
};
export const hideUpdatePanel = () => (dispatch) =>
  dispatch({
    type: 'HIDE_UPDATE_PANEL',
  });

export const handleContinue = (row) => (dispatch) => {
  dispatch({
    type: 'SHOW_UPDATE_PANEL',
    payload: row,
  });
  dispatch({
    type: 'HIDE_CONFIRMATION',
  });
};

export const closeConfirmationDialog = () => (dispatch) =>
  dispatch({
    type: 'HIDE_CONFIRMATION',
  });

export const getFeed = (input) => (dispatch) => {
  api
    .getFeed(input)
    .then((res) => {
      dispatch({
        type: 'UPDATE_FEED',
        payload: res.data,
      });
    })
    .catch((err) => {
      if (err.response.status === 401)
        dispatch({
          type: 'LOGOUT',
        });
      else
        dispatch({
          type: 'API_ERROR',
        });
    });
};

export const getSuggestions = () => (dispatch) => {
  api
    .getSuggestions()
    .then((res) => {
      dispatch({
        type: 'GET_SUGGESTIONS',
        payload: {
          suggestions: res.data.suggestions,
        },
      });
    })
    .catch((err) => {
      if (err.response.status === 401)
        dispatch({
          type: 'LOGOUT',
        });
      else
        dispatch({
          type: 'API_ERROR',
        });
    });
};

export const approveSuggestion = (id, input) => (dispatch) => {
  api
    .approveSuggestion(id)
    .then((res) => {
      dispatch({
        type: 'APPROVE_SUGGESTION',
        payload: res.data,
      });
      dispatch({
        type: 'UPDATE_PRICE',
        payload: input,
      });
    })
    .catch((err) => {
      if (err.response.status === 401) {
        dispatch({
          type: 'LOGOUT',
        });
      } else if (err.response.status === 405) {
        dispatch({
          type: 'API_ERROR',
          payload: err.response.data.error,
        });
      } else {
        dispatch({
          type: 'API_ERROR',
        });
      }
    });
};

export const getCompetitorData = (input) => (dispatch) => {
  api
    .getCompetitorData(input)
    .then((res) => {
      dispatch({
        type: 'UPDATE_COMPETITOR_DATA',
        payload: res.data,
      });
    })
    .catch((err) => {
      if (err.response.status === 401)
        dispatch({
          type: 'LOGOUT',
        });
      else
        dispatch({
          type: 'API_ERROR',
        });
    });
};
